"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploadLabelDefault = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../../UIElements/Icons/PetSure/Icon");
var _formFieldPropTypes = require("../../../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileUploadLabelDefault = _ref => {
  let {
    label,
    validFiles
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", null, label, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "file-text"
  }), /*#__PURE__*/_react.default.createElement("strong", null, "Drop your files here, or click to ", /*#__PURE__*/_react.default.createElement("em", null, "browse")), /*#__PURE__*/_react.default.createElement("small", null, "Supports: ", validFiles.supportsLabel, " "));
};
exports.FileUploadLabelDefault = FileUploadLabelDefault;
FileUploadLabelDefault.propTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  validFiles: _formFieldPropTypes.ValidFilesPropTypes
};